function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\uD83C\uDF08 COLOR");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-icons-/-info-circle",
  transform: "translate(-2.000000, -2.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M12,11 C11.4477152,11 11,11.4477152 11,12 L11,16 C11,16.5522848 11.4477152,17 12,17 C12.5522848,17 13,16.5522848 13,16 L13,12 C13,11.4477152 12.5522848,11 12,11 Z M12.38,7.08 C12.1365386,6.97998198 11.8634614,6.97998198 11.62,7.08 C11.4972487,7.12759438 11.3851037,7.19895937 11.29,7.29 C11.2016691,7.38720094 11.1306419,7.4988151 11.08,7.62 C11.0240186,7.73867938 10.9966199,7.86882346 11,8 C10.9984632,8.26580298 11.1028135,8.52128117 11.29,8.71 C11.3872009,8.79833093 11.4988151,8.86935813 11.62,8.92 C11.9276385,9.04638789 12.277982,9.011556 12.5547126,8.8270689 C12.8314433,8.6425818 12.9983432,8.33258472 13,8 C12.9963165,7.73523301 12.8927337,7.48163378 12.71,7.29 C12.6148963,7.19895937 12.5027513,7.12759438 12.38,7.08 Z M12,1.99999999 C6.4771525,1.99999999 1.99999999,6.4771525 1.99999999,12 C1.99999999,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,9.3478351 20.9464316,6.80429597 19.0710678,4.92893218 C17.195704,3.05356839 14.6521649,1.99999999 12,1.99999999 Z M12,20 C7.581722,20 3.99999999,16.418278 3.99999999,12 C3.99999999,7.581722 7.581722,3.99999999 12,3.99999999 C16.418278,3.99999999 20,7.581722 20,12 C20,14.1217319 19.1571453,16.1565632 17.6568543,17.6568543 C16.1565632,19.1571453 14.1217319,20 12,20 Z",
  id: "\\uD83C\\uDF08-COLOR"
})));

var SvgInfoCircle = function SvgInfoCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfoCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-circle.81ccf92c.svg";
export { ForwardRef as ReactComponent };